function addOrigin(origins, value) {
  if (!value || typeof value !== 'string') {
    return;
  }

  try {
    origins.add(new URL(value).origin);
  } catch {
    // ignore invalid URLs
  }
}

export function resolveParentOrigins() {
  const origins = new Set();

  addOrigin(origins, import.meta.env.VITE_PARENT_URL);
  addOrigin(origins, import.meta.env.VITE_NIAP);

  if (document.referrer) {
    addOrigin(origins, document.referrer);
  }

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    addOrigin(origins, 'http://127.0.0.1:4201');
    addOrigin(origins, 'http://localhost:4201');
  }

  addOrigin(origins, 'https://nplanner.ru');
  addOrigin(origins, 'https://stage.nutrientplaner.ru');
  addOrigin(origins, 'https://nutrientplaner.ru');

  const selfOrigin = window.location.origin;
  return [...origins].filter((origin) => origin && origin !== selfOrigin);
}

export function postToParent(payload) {
  if (window.parent === window) {
    return;
  }

  for (const origin of resolveParentOrigins()) {
    try {
      window.parent.postMessage(payload, origin);
    } catch {
      // skip invalid target origins
    }
  }
}
